import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './personallferrari_antesdepois.module.scss';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5511940661541';
const WHATSAPP_MSG_ANTESDEPOIS =
    'Olá! Vi os antes e depois no site e quero saber como começar minha transformação com você. Podemos conversar?';

const whatsappAntesDepoisLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG_ANTESDEPOIS)}`;

const GALLERY_ITEMS: { src: string; label: string }[] = [
    { src: require('./src/antesdepois/antesdepois_1.png'), label: 'Resultado 1' },
    { src: require('./src/antesdepois/antesdepois_2.png'), label: 'Resultado 2' },
    { src: require('./src/antesdepois/antesdepois_3.png'), label: 'Resultado 3' },
    { src: require('./src/antesdepois/antesdepois_4.png'), label: 'Resultado 4' },
    { src: require('./src/antesdepois/antesdepois_5.png'), label: 'Resultado 5' },
    { src: require('./src/antesdepois/antesdepois_6.png'), label: 'Resultado 6' },
    { src: require('./src/antesdepois/antesdepois_7.png'), label: 'Resultado 7' },
    { src: require('./src/antesdepois/antesdepois_8.png'), label: 'Resultado 8' },
];

const Personallferrari_antesdepois: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.personallferrari_antesdepois}>
            <div className={styles.page}>
                <div className={styles.header}>
                    <Link
                        to="/personallferrari"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao cartão digital"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Personal Ferrari</p>
                        <h1 className={styles.title}>Antes e depois</h1>
                    </div>
                </div>

                <p className={styles.intro}>
                    Transformações reais de quem confia no método. Cada caso é único.
                    Resultados dependem de constância, nutrição e orientação profissional.
                </p>

                <div className={styles.grid}>
                    {GALLERY_ITEMS.map((item, index) => (
                        <figure key={item.src} className={styles.card}>
                            <img
                                src={item.src}
                                alt={`Antes e depois — ${item.label}`}
                                className={styles.cardImage}
                                loading={index < 2 ? 'eager' : 'lazy'}
                            />
                            <figcaption className={styles.cardFigcaption}>{item.label}</figcaption>
                        </figure>
                    ))}
                </div>

                <p className={styles.footerNote}>
                    Resultados individuais variam conforme constância nos treinos, alimentação e perfil de cada pessoa.
                </p>

                <div className={styles.ctaSection} aria-labelledby="cta-antesdepois-heading">
                    <h2 id="cta-antesdepois-heading" className={styles.ctaHeading}>
                        Sua próxima foto pode ser a sua transformação
                    </h2>
                    <p className={styles.ctaText}>
                        Vagas limitadas para acompanhamento personalizado. Chame no WhatsApp, tire suas dúvidas e dê o
                        primeiro passo com quem já entregou resultados reais.
                    </p>
                    <a
                        href={whatsappAntesDepoisLink}
                        className={styles.ctaWhatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="22" color="#ffffff" />
                        <span>Falar no WhatsApp agora</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Personallferrari_antesdepois;
